import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

if (
  process.env.NODE_ENV !== 'development' &&
  process.env.DD_APPLICATION_ID &&
  process.env.DD_CLIENT_TOKEN
) {
  datadogRum.init({
    applicationId: process.env.DD_APPLICATION_ID,
    clientToken: process.env.DD_CLIENT_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'admin',
    env: process.env.GATSBY_ENV_LEVEL === 'prod' ? 'prod' : 'dev',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 1,
    traceSampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    version: process.env.SENTRY_RELEASE,
    defaultPrivacyLevel: 'mask',
    enablePrivacyForActionName: true,
  });
  datadogLogs.init({
    clientToken: process.env.DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'admin',
    env: process.env.GATSBY_ENV_LEVEL === 'prod' ? 'prod' : 'dev',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    version: process.env.SENTRY_RELEASE,
  });
}
